import { useEffect, useState } from 'react';

import AddShippingProvider from '../../components/shipping/shipping-provider/add/add-shipping-provider.component';
import AddShippingType from '../../components/shipping/shipping-type/add/add-shipping-type.component';
import Button from '../../components/reusable/button/button.component';
import ComponentModal from '../../components/reusable/component-modal/component-modal.component';
import ShippingOptionsTab from '../../components/shipping/shipping-options/tab/shipping-options-tab.component';
import ShippingProviderDisplay from '../../components/shipping/shipping-provider/display/shipping-provider-display.components';
import ShippingTypeDisplay from '../../components/shipping/shipping-type/display/shipping-type-display.components';
import Spinner from '../../components/reusable/spinner/spinner.component';

import Client from '../../tools/client';

import {
  ContentContainer,
  MainContainer,
  MainTitle,
  Subtitle,
  TabContainer,
  TabSelector,
} from '../../styles/page.styles';

const client = new Client();

const ShippingPage = () => {
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('options');

  const [options, setOptions] = useState([]);
  const [providers, setProviders] = useState([]);
  const [types, setTypes] = useState([]);

  const [showAddProvider, setShowAddProvider] = useState(false);
  const [showAddType, setShowAddType] = useState(false);

  useEffect(() => {
    loadShippingData();
  }, []);

  const loadShippingData = async () => {
    setLoading(true);
    const [optionsRes, providersRes, typesRes] = await Promise.all([
      client.getShippingOptions(),
      client.getShippingProviders(),
      client.getShippingTypes()
    ]);
    setOptions(optionsRes);
    setProviders(providersRes);
    setTypes(typesRes);
    setLoading(false);
  };

  const renderTabContent = () => {
    switch (tab) {
      case 'options':
        return (
          <ShippingOptionsTab
            options={options}
            providers={providers}
            types={types}
            reload={loadShippingData}
          />
        );
      case 'providers':
        return (
          <>
            <ComponentModal isOpen={showAddProvider} onClose={() => setShowAddProvider(false)} title="Add Shipping Provider">
              <AddShippingProvider />
            </ComponentModal>
            <Button onClick={() => setShowAddProvider(true)}>Add Shipping Provider</Button>
            {providers.map((provider) => (
              <ShippingProviderDisplay key={provider.id} provider={provider} getProvider={loadShippingData} />
            ))}
          </>
        );
      case 'types':
        return (
          <>
            <ComponentModal isOpen={showAddType} onClose={() => setShowAddType(false)} title="Add Shipping Type">
              <AddShippingType />
            </ComponentModal>
            <Button onClick={() => setShowAddType(true)}>Add Shipping Type</Button>
            {types.map((type) => (
              <ShippingTypeDisplay key={type.id} type={type} getType={loadShippingData} />
            ))}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <MainContainer>
      {loading ? (
        <Spinner />
      ) : (
        <ContentContainer>
          <MainTitle>Shipping Management</MainTitle>

          <TabContainer>
            <TabSelector active={tab === 'options'} onClick={() => setTab('options')}>Options</TabSelector>
            <TabSelector active={tab === 'providers'} onClick={() => setTab('providers')}>Providers</TabSelector>
            <TabSelector active={tab === 'types'} onClick={() => setTab('types')}>Types</TabSelector>
          </TabContainer>

          <Subtitle>{tab.charAt(0).toUpperCase() + tab.slice(1)}</Subtitle>

          {renderTabContent()}
        </ContentContainer>
      )}
    </MainContainer>
  );
};

export default ShippingPage;